import { useMutation } from "react-query";
import { PartnerApi } from "../../api/partner.api";
import { useLoansStore } from "../../store/loans.store";

export const useLoans = () => {
  const setLoans = useLoansStore((state) => state.setLoans);

  return useMutation(PartnerApi.loans, {
    onSuccess: (data) => {
      setLoans(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};

export const useLoansCompanyDetail = () => {
  const setLoansCompanyDetail = useLoansStore(
    (state) => state.setLoansCompanyDetail
  );

  return useMutation(PartnerApi.loans, {
    onSuccess: (data) => {
      setLoansCompanyDetail(data);
    },
    onError: (error) => {
      console.error("Login failed:", error);
    },
  });
};
